import { OVERDUE_WEEKS } from "@/pregnancy";

export const GA_ALERT_ICON_COLOR = "var(--mantine-color-orange-6)";

export const GA_ALERT_SUBTITLE = "Ensure you have closed out the pregnancy if applicable.";

export const GA_ALERT_TOOLTIP_MESSAGE = `GA is ${OVERDUE_WEEKS}+ weeks. ${GA_ALERT_SUBTITLE}`;

export const GA_ALERT_TITLE = `Gestational Age is ${OVERDUE_WEEKS}+ weeks.`;

export const GA_ALERT_SIGN_MODAL_TITLE = `Gestational Age is ${OVERDUE_WEEKS}+ weeks!`;

export const GA_ALERT_SIGN_SUBTITLE =
  "After signing & locking this encounter, ensure you have closed out the pregnancy if applicable.";
